<div class="flex align-items-center">
  @if (showPassword) {
    <div class="mr-2">{{ password }}</div>
  } @else {
    <div class="mr-2 flex justify-content-center line-height-3" style="height: 1rem">{{ password | maskPassword }}</div>
  }
  <p-button [icon]="showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'"
            [text]="true"
            severity="secondary"
            [style]="{padding: '0.175rem', width: '1.55rem'}"
            [pTooltip]="i18n.i18nLng()[showPassword ? 'MASKPASSWORD' : 'SHOWPASSWORD']"
            [attr.aria-label]="i18n.i18nLng()[showPassword ? 'MASKPASSWORD' : 'SHOWPASSWORD']"
            (click)="changePasswordMask()"/>
  <p-button icon="pi pi-copy"
            [text]="true"
            severity="secondary"
            [style]="{padding: '0.175rem', width: '1.55rem'}"
            [pTooltip]="i18n.i18nLng()['COPYPWCLIPBOARD']"
            [attr.aria-label]="i18n.i18nLng()['COPYPWCLIPBOARD']"
            (click)="copyPasswordToClipboard()"/>
</div>
